import OrderItemInterface from '../constants/interfaces/order-item-interface';
import { OrderItemType } from '../constants/types/order-item';
import CartItem from './cart-item';

export default class OrderItem implements OrderItemInterface {
  order: OrderItemType;
  constructor(props: OrderItemType) {
    this.order = props;
  }

  get date() {
    return this.order.date;
  }

  get orderId() {
    return this.order.order;
  }

  get totalPrice() {
    return this.order.totals.grandTotalPrice;
  }

  get totalPriceAsNumber() {
    return this.order.totals.grandTotalPriceAsNumber;
  }

  get shippingCost() {
    return this.order.totals.shippingPrice;
  }

  get totalDiscount() {
    return this.order.discounts.discount;
  }

  get items() {
    return this.order.items.map((item) => new CartItem({ cartItem: item }));
  }

  get hasDiscount() {
    return this.order.discounts.anyDiscount;
  }

  get shippingMethod() {
    return this.order.shippingMethod;
  }

  get statusDescription() {
    return this.order.statusDescription;
  }

  get address() {
    return this.order.address;
  }

  get currency() {
    return this.order.currency;
  }

  get shippingPriceAsNumber() {
    return this.order.totals.shippingPriceAsNumber;
  }

  get taxAddedAsNumber() {
    return this.order.totals.grandTotalPriceTaxAsNumber;
  }

  get voucher() {
    return this.order.discounts.vouchers.length > 0
      ? this.order.discounts.vouchers[0].voucher
      : '';
  }

  get additionalNotes() {
    return this.order.additionalNotes || '';
  }

  get shippingAddress() {
    return this.order.shippingAddress;
  }

  get paymentMethod() {
    return this.order.paymentMethod;
  }
}
